import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=6874cfcd&scoped=true"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"
import style0 from "./Base.vue?vue&type=style&index=0&id=6874cfcd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6874cfcd",
  null
  
)

export default component.exports